// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amount-box {
  background: rgba(0, 0, 0, 0.5294117647);
  position: absolute;
  z-index: 45;
  top: 0;
  width: 100%;
  height: 100%;
  min-height: 30px;
  font-size: 25px;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
}

.amount-box .amount-control-row .amount-control-btn {
  background: #fac75a;
  color: #000;
  height: 28px;
  line-height: 1.4;
  font-size: 20px;
  width: 100%;
  transition: opacity 0.4s ease-in-out;
}

.amount-box .amount-control-row .amount-control-btn:active {
  opacity: 0.4;
}

.amount-box .amount-control-row .col {
  line-height: 1;
}

.amount-box .amount-control-row .amount-control-btn.right {
  margin-left: 1px;
  border-top-right-radius: 20px;
}

.amount-box .amount-control-row .amount-control-btn.left {
  border-top-left-radius: 20px;
  margin-right: 1px;
}

.slider-box {
  min-height: 30px;
  margin: 2px 4px;
  color: #fff;
  text-align: center;
  font-size: 35px;
  position: relative;
}

.slider-box.active {
  border-color: #7cd259;
}

.slider-box.active.full-width {
  width: 100%;
}

.slider-body {
  position: absolute;
  background: #ac1f25;
  width: 100%;
  z-index: 50;
  font-size: 17px;
  bottom: 0;
  top: auto;
}

.slider-body.bottom {
  bottom: 0;
  top: auto;
}

.slider-body .icon {
  font-size: 80px;
  text-shadow: 2px 2px 2px #000;
}

.slider-body .title {
  text-align: center;
  color: #fff;
  font-size: 14px;
  padding: 5px 2px 2px;
  line-height: 1;
}

.slider-body .title.active {
  background: #fac75a;
  color: #322b1d;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/framework/components/core/dynamic-slider-body/dynamic-slider-body.component.scss"],"names":[],"mappings":"AAAA;EAEE,uCAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,4BAAA;AAAF;;AAQA;EAEE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EAMA,oCAAA;AAPF;;AAUA;EAEE,YAAA;AARF;;AAWA;EAEE,cAAA;AATF;;AAYA;EAEE,gBAAA;EACA,6BAAA;AAVF;;AAYA;EAEE,4BAAA;EACA,iBAAA;AAVF;;AAcA;EAEE,gBAAA;EACA,eAAA;EAIA,WAAA;EACA,kBAAA;EAEA,eAAA;EACA,kBAAA;AAhBF;;AAqBA;EACE,qBAAA;AAlBF;;AAwBA;EACE,WAAA;AArBF;;AAyBA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,SAAA;AAtBF;;AA0BA;EACE,SAAA;EACA,SAAA;AAvBF;;AAgCA;EACE,eAAA;EACA,6BAAA;AA7BF;;AAiCA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;AA9BF","sourcesContent":[".amount-box\n{\n  background: #00000087;\n  position: absolute;\n  z-index: 45;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  min-height: 30px;\n  font-size: 25px;\n  border-top-right-radius: 20px;\n  border-top-left-radius: 20px;\n}\n\n.amount-box .amount-control-row\n{\n\n}\n\n.amount-box .amount-control-row .amount-control-btn\n{\n  background: #fac75a;\n  color: #000;\n  height: 28px;\n  line-height: 1.4;\n  font-size: 20px;\n  width: 100%;\n\n  -webkit-transition: opacity 0.4s ease-in-out;\n  -moz-transition: opacity 0.4s ease-in-out;\n  -ms-transition: opacity 0.4s ease-in-out;\n  -o-transition: opacity 0.4s ease-in-out;\n  transition: opacity 0.4s ease-in-out;\n}\n\n.amount-box .amount-control-row .amount-control-btn:active\n{\n  opacity: 0.4;\n}\n\n.amount-box .amount-control-row .col\n{\n  line-height: 1;\n}\n\n.amount-box .amount-control-row .amount-control-btn.right\n{\n  margin-left: 1px;\n  border-top-right-radius: 20px;\n}\n.amount-box .amount-control-row .amount-control-btn.left\n{\n  border-top-left-radius: 20px;\n  margin-right: 1px;\n}\n\n\n.slider-box {\n  //width: 150px;\n  min-height: 30px;\n  margin: 2px 4px;\n  //background: #a05256;\n  //border: 2px solid #fff;\n  //border-style: dashed;\n  color: #fff;\n  text-align: center;\n  //padding: 55px 20px;\n  font-size: 35px;\n  position: relative;\n  //width:50%;\n  //margin:10px 80px;\n}\n\n.slider-box.active {\n  border-color: #7cd259;\n  //margin:10px;\n  //width:100%;\n  //border-color: #7cd259d4;\n}\n\n.slider-box.active.full-width {\n  width: 100%;\n}\n\n\n.slider-body {\n  position: absolute;\n  background: #ac1f25;\n  width: 100%;\n  z-index: 50;\n  font-size: 17px;\n  bottom: 0;\n  top: auto;\n\n}\n\n.slider-body.bottom {\n  bottom: 0;\n  top: auto;\n}\n\n\n.slider-body.none {\n  //font-size: 19px;\n  //padding: 23px;\n}\n\n.slider-body .icon {\n  font-size: 80px;\n  text-shadow: 2px 2px 2px #000;\n  //padding: 23px;\n}\n\n.slider-body .title {\n  text-align: center;\n  color: #fff;\n  font-size: 14px;\n  padding: 5px 2px 2px;\n  line-height: 1;\n}\n\n.slider-body .title.active {\n  background: #fac75a;\n  color:#322b1d;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
